import React, { useEffect, useState } from 'react'
import './index.scss'
import Button from '@Components/Buttons/Button'
import { RIGHTSHOLDER_GROUP } from '@Const/rightsholder-statuses'
import ModalPortal from '@Components/Popups/ModalPortal'
import ButtonRegistrationRightsHolder from '@Components/Buttons/ButtonRegistrationRightsHolder'
import TopRightsHoldersSection from '@Components/topRightsHoldersSection'
import Navigation from '@App/navigation'
import { Rightsholders } from '@Entities/rightsholder'
import { getRightsholders } from '@App/api/routes/rightsholder/rightsholder'
import { generateRightsholderPaginationStatus } from '@App/helpers/get-rigthsholder-pagination-status'
import { calcNumPages } from '@App/helpers/pagination/calc-num-pages'
import { PaginationBody, PaginationBodyRightsHolders, PaginationInfo } from '@Entities/pagination'

const ProfileSceneRightsholderTab = () => {
    const limitItems = 6
    const [pendingData, setPendingData] = useState<{ data: Rightsholders; pagination: PaginationInfo | undefined }>()
    const [failedData, setFailedData] = useState<{ data: Rightsholders; pagination: PaginationInfo | undefined }>()
    const [pendingPreloader, setPendingPreloader] = useState(true)
    const [failedPreloader, setFailedPreloader] = useState(true)
    const [isPopupOpen, setPopupOpen] = useState(false)
    const [rightsholderIdRedirect, setRightsholderIdRedirect] = useState<number>()

    const setOpeningStatusPopup = (status: boolean, id?: number) => {
        setPopupOpen(status)
        if (id) {
            setRightsholderIdRedirect(id)
        }
    }

    const getRightsHolders = async (
        status: string | undefined,
        pending: boolean | undefined,
        callBackPagination?: PaginationBody
    ) => {
        const newStatus = generateRightsholderPaginationStatus(status)

        const body: PaginationBodyRightsHolders = {
            limit: limitItems,
            page: 1,
            ...(newStatus && { status: newStatus }),
            pending,
            ...(callBackPagination && callBackPagination),
        }

        // Bypass the store for these, they're not used elsewhere
        const rightsholderResponse = await getRightsholders(body)
        const rightsholders = rightsholderResponse.data

        let nextPagination
        if (body && body.limit && body.page && rightsholders) {
            nextPagination = calcNumPages(rightsholders.count, body.limit, body.page)
        }

        return { data: rightsholders, pagination: nextPagination }
    }

    const getPendingRightsHolders = async (callBackPagination?: PaginationBody) => {
        const result = await getRightsHolders(RIGHTSHOLDER_GROUP.pending, true, callBackPagination)
        setPendingData(result)
        setPendingPreloader(false)
    }

    const getFailedRightsHolders = async (callBackPagination?: PaginationBody) => {
        const result = await getRightsHolders(RIGHTSHOLDER_GROUP.failed, undefined, callBackPagination)
        setFailedData(result)
        setFailedPreloader(false)
    }

    useEffect(() => {
        Promise.all([getPendingRightsHolders(), getFailedRightsHolders()]).then()
    }, [])

    const fullCount = pendingData && failedData && pendingData.data.count + failedData.data.count

    return (
        <>
            <div className="profile-scene-rightsholder-tab">
                <div className="tab-head">
                    <h5>
                        {fullCount}&nbsp;{fullCount === 1 ? 'Member' : 'Members'}
                    </h5>
                    <ButtonRegistrationRightsHolder mainColor />
                </div>
                <TopRightsHoldersSection
                    name="Pending"
                    rightsHolders={pendingData && pendingData.data}
                    preloader={pendingPreloader}
                    limitItems={limitItems}
                    openPopup={setOpeningStatusPopup}
                    paginationPages={pendingData && pendingData.pagination}
                    onChangePagination={getPendingRightsHolders}
                    viewDetails={false}
                />
                <TopRightsHoldersSection
                    name="Failed"
                    rightsHolders={failedData && failedData.data}
                    preloader={failedPreloader}
                    limitItems={limitItems}
                    openPopup={setOpeningStatusPopup}
                    paginationPages={failedData && failedData.pagination}
                    onChangePagination={getFailedRightsHolders}
                    viewDetails={false}
                />
            </div>
            <ModalPortal isOpen={isPopupOpen}>
                <div className="redirect-verification-popup">
                    <h3>Please review your mailing and financial information.</h3>
                    <div className="links-block">
                        <Button
                            mainColor
                            type="secondary"
                            onClick={() => {
                                setOpeningStatusPopup(false)
                            }}
                        >
                            CANCEL
                        </Button>
                        {rightsholderIdRedirect && (
                            <Button
                                mainColor
                                type="primary"
                                typeLink
                                linkTo={Navigation.rightholder.maintenance.root(rightsholderIdRedirect)}
                            >
                                REVIEW INFO
                            </Button>
                        )}
                    </div>
                </div>
            </ModalPortal>
        </>
    )
}

export default ProfileSceneRightsholderTab
